/**
 * @generated SignedSource<<6b4ce837fa6f66604e6d014f0b9de690>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StartSubmissionReportPageQuery$variables = {
  submissionId: string;
};
export type StartSubmissionReportPageQuery$data = {
  readonly landlordOnboardingSubmission: {
    readonly " $fragmentSpreads": FragmentRefs<"StartReport_submission">;
  } | null | undefined;
};
export type StartSubmissionReportPageQuery = {
  response: StartSubmissionReportPageQuery$data;
  variables: StartSubmissionReportPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submissionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "submissionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "langfuseUrl",
      "storageKey": null
    }
  ],
  "type": "ILangfuseTraceable",
  "abstractKey": "__isILangfuseTraceable"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percent",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amountPence",
    "storageKey": null
  },
  (v4/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StartSubmissionReportPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordOnboardingSubmission",
        "kind": "LinkedField",
        "name": "landlordOnboardingSubmission",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StartReport_submission"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "StartSubmissionReportPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordOnboardingSubmission",
        "kind": "LinkedField",
        "name": "landlordOnboardingSubmission",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordAgentSearch",
            "kind": "LinkedField",
            "name": "agentSearch",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLine1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "town",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postcode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "branchesFound",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "branchesCompleted",
                "storageKey": null
              },
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordAgentSearchFeedback",
                "kind": "LinkedField",
                "name": "feedback",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rating",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "topResults",
                "args": null,
                "concreteType": "LandlordAgentFinderResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordDiscoveredBranch",
                    "kind": "LinkedField",
                    "name": "branch",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "address",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "website",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "googleRating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "googleReviewCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trustpilotRating",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trustpilotReviewCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "strengths",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "considerations",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LandlordDiscoveredBranchFees",
                        "kind": "LinkedField",
                        "name": "fees",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LandlordDiscoveredBranchFee",
                            "kind": "LinkedField",
                            "name": "management",
                            "plural": false,
                            "selections": [
                              (v4/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LandlordDiscoveredBranchFee",
                            "kind": "LinkedField",
                            "name": "tenantFind",
                            "plural": false,
                            "selections": (v5/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LandlordDiscoveredBranchFee",
                            "kind": "LinkedField",
                            "name": "letOnly",
                            "plural": false,
                            "selections": (v5/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "feesIncludeVat",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "distanceMeters",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandlordDiscoveredBranchEnrichmentRun",
                    "kind": "LinkedField",
                    "name": "enrichmentRun",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordNegotiationRequest",
            "kind": "LinkedField",
            "name": "negotiationRequest",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5761b3c9ffac3bc9caa9f8ad233a2c41",
    "id": null,
    "metadata": {},
    "name": "StartSubmissionReportPageQuery",
    "operationKind": "query",
    "text": "query StartSubmissionReportPageQuery(\n  $submissionId: ID!\n) {\n  landlordOnboardingSubmission(id: $submissionId) {\n    ...StartReport_submission\n    id\n  }\n}\n\nfragment StartBranchCard_result on LandlordAgentFinderResult {\n  distanceMeters\n  enrichmentRun {\n    ...StartLangfuseLink_traceable\n    id\n  }\n  branch {\n    name\n    address\n    website\n    googleRating\n    googleReviewCount\n    trustpilotRating\n    trustpilotReviewCount\n    strengths\n    considerations\n    fees {\n      management {\n        percent\n      }\n      tenantFind {\n        amountPence\n        percent\n      }\n      letOnly {\n        amountPence\n        percent\n      }\n      feesIncludeVat\n    }\n    id\n  }\n}\n\nfragment StartLangfuseLink_traceable on ILangfuseTraceable {\n  __isILangfuseTraceable: __typename\n  langfuseUrl\n}\n\nfragment StartReportFeedback_search on LandlordAgentSearch {\n  id\n  feedback {\n    id\n    rating\n    text\n  }\n}\n\nfragment StartReportNegotiation_submission on LandlordOnboardingSubmission {\n  id\n  negotiationRequest {\n    __typename\n    id\n  }\n}\n\nfragment StartReport_search on LandlordAgentSearch {\n  id\n  status\n  addressLine1\n  town\n  postcode\n  branchesFound\n  branchesCompleted\n  ...StartLangfuseLink_traceable\n  ...StartReportFeedback_search\n  topResults: results {\n    branch {\n      id\n    }\n    ...StartBranchCard_result\n  }\n}\n\nfragment StartReport_submission on LandlordOnboardingSubmission {\n  agentSearch {\n    ...StartReport_search\n    id\n  }\n  ...StartReportNegotiation_submission\n}\n"
  }
};
})();

(node as any).hash = "1fce1260f353760722687e8f3a6caa51";

export default node;
